// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-section {
    text-align: center;
    padding: .25rem .25rem;
    background-color: #dddddd;
  }
  
  .hero-section h1, .hero-section p {
    font-size: 2.5rem;
    font-family: "Roboto";
  }
  
  .hero-section p {
    font-size: 1.5rem;
  }
  
  @media (max-width: 768px) {
    
    .hero-section h1 {
      font-size: 2rem;
    }
  
    .hero-section p {
      font-size: 1rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/HeroSection.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":[".hero-section {\r\n    text-align: center;\r\n    padding: .25rem .25rem;\r\n    background-color: #dddddd;\r\n  }\r\n  \r\n  .hero-section h1, .hero-section p {\r\n    font-size: 2.5rem;\r\n    font-family: \"Roboto\";\r\n  }\r\n  \r\n  .hero-section p {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  @media (max-width: 768px) {\r\n    \r\n    .hero-section h1 {\r\n      font-size: 2rem;\r\n    }\r\n  \r\n    .hero-section p {\r\n      font-size: 1rem;\r\n    }\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
